import { useQuery } from '@tanstack/react-query'
import { AXIOS_INSTANCE } from '../api'
import { InventoryLocationResponse } from '../types/inventoryLocation.type'

export const useInventoryLocation = () => {
  const { data, isLoading } = useQuery({
    queryKey: ['inventory-locations'],
    queryFn: async () => {
      const { data } = await AXIOS_INSTANCE.get<InventoryLocationResponse>('inventory_locations')
      return data
    }
  })

  return {
    inventoryLocations: data?.data,
    inventoryLocationsPagination: data?.meta?.pagination,
    inventoryLocationsIncluded: data?.included,
    isLoading
  }
}
